// extracted by mini-css-extract-plugin
module.exports = {"terminator":"_2Bl57","description":"SLkwd","cta":"_3i4Gj","icon":"_3i01u"};